export default __webpack_public_path__ + "static/media/zach.1691e0c6.jpeg";